import { render, staticRenderFns } from "./MenuToggleBtn.vue?vue&type=template&id=2fc74e7c&"
import script from "./MenuToggleBtn.vue?vue&type=script&lang=js&"
export * from "./MenuToggleBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports